import { findClosest } from "./utils/utils";

const handleToggle = (step) => {
    const container = step.closest('.risk-indicator');
    const details = container?.querySelector('.risk-indicator__details');
    const detailsContainer = container?.querySelector('.risk-indicator__details-container');
    step.classList.toggle('show');
    details?.classList.toggle('show');
    detailsContainer?.classList.toggle('show');
};

document.addEventListener('click', (e) => {
    const target = findClosest(e.target, '.risk-indicator__step--highlighted');
    if (target && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
      handleToggle(target);
    }
});

document.addEventListener('mouseover', (e) => {
    const target = findClosest(e.target, '.risk-indicator__step--highlighted');
    if (target && !('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
      const container = target.closest ? target.closest('.risk-indicator') : findClosest(target, '.risk-indicator');
      const detailsContainer = container?.querySelector('.risk-indicator__details-container');
      const details = container?.querySelector('.risk-indicator__details');
      target.classList.add('show');
      details?.classList.add('show');
      detailsContainer?.classList.add('show');
    }
});

document.addEventListener('mouseout', (e) => {
    const target = findClosest(e.target, '.risk-indicator__step--highlighted');
    if (target && !('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
      const container = target.closest ? target.closest('.risk-indicator') : findClosest(target, '.risk-indicator');
      const detailsContainer = container?.querySelector('.risk-indicator__details-container');
      const details = container?.querySelector('.risk-indicator__details');
      target.classList.remove('show');
      details?.classList.remove('show');
      detailsContainer?.classList.remove('show');
    }
});

document.addEventListener('click', function(e) {
    const target = e.target.closest('.fund-data-row__fund-details-content img');
    if (!target) return;
    
    const copiedText = target.getAttribute("data-copiedtext") || "Copied";
    const data = target.getAttribute("data-value");
    
    if (data) {
        navigator.clipboard.writeText(data);
        $(target).tooltip("dispose");
        target.setAttribute("title", copiedText);
        $(target).tooltip({ trigger: 'manual' });
        $(target).tooltip('show');
        
        setTimeout(() => {
            $(target).tooltip("hide");
        }, 1000);
    }
});

const brokerModalHeaderBtn = document.querySelector('.broker-clickout .bc-faq__heading');
brokerModalHeaderBtn?.addEventListener('click', (e) => {
      const bcFaqBody = document.querySelector('.broker-clickout .bc-faq__body');
      bcFaqBody.classList.toggle('collapse');
})